var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit-3",
    "data-name": "Icon feather-edit-3",
    transform: "translate(-4.5 -4.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12023",
    "data-name": "Path 12023",
    d: "M20.077,5.035A2.448,2.448,0,0,1,23.538,8.5L9.115,22.92,4.5,24.073l1.154-4.615Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5527",
    "data-name": "Rectangle 5527",
    width: 15,
    height: 3,
    rx: 1.5,
    transform: "translate(12.5 21.318)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/edit icon.279bea80a0b6627364f6999e4fbb93fb.svg";
export { ForwardRef as ReactComponent };